<template lang="pug">
.st-btn(
  :class="{ hidden: hidden }"
  @click.prevent="click"
)
</template>

<script>
let VueScrollTo = require('vue-scrollto');

export default {
  properties: {
    speed: {
      type: Number,
      default: 500,
    },
    easing: {
      type: String,
      default: 'ease-in-out',
    },
  },

  data() {
    return { hidden: true };
  },

  mounted() {
    this.onScroll();
    window.addEventListener('scroll', this.onScroll, false);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll);
  },

  methods: {
    click() {
      VueScrollTo.scrollTo('body', this.speed, {
        easing: this.easing,
      });
    },

    onScroll() {
      this.hidden = !window.scrollY;
    },
  },
};
</script>

<style scoped>
.st-btn {
  display: block;
  width: 40px;
  height: 40px;
  cursor: pointer;
  z-index: 999;
  border-radius: 50%;
  overflow: hidden;
  background: url(./pageup-min.png) 50% no-repeat;
  background-size: cover;
  opacity: 0.5;
  transition: opacity 150ms ease-in;
}

.hidden {
  cursor: default;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// component.vue?e3548344